import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class EstadoMaquinaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerTodos(callback) {
        this.gqlclient.query({
            query: gql `
          {
            estado_maquina {
              obtenerTodos {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    nombre
                    codigo
                    descripcion
                  }
                }
              }
            }
          }
        `,
            variables: {},
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.estado_maquina.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerEstadosNoInactivo(callback) {
        this.gqlclient.query({
            query: gql `
          {
            estado_maquina {
              obtenerSegunFiltro {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    nombre
                    codigo
                    descripcion
                  }
                }
              }
            }
          }
        `,
            variables: {},
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.estado_maquina.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
}
EstadoMaquinaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EstadoMaquinaService_Factory() { return new EstadoMaquinaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: EstadoMaquinaService, providedIn: "root" });
